<template>
  <CustomDeleteDialog

  dialogId="delete-reserved-schedule-confirmation"
    okTitle="حذف"
    no-close-on-backdrop
    @ok="getSecondConfirmation"
  >
    <BCol cols="12">
      <p>
        آیا از حذف تعداد
        <span class="font-weight-bolder">
          {{ selectedSchedulesLength }}
          جلسه
        </span>
        رزرو شده اطمینان دارید؟ در نظر داشته باشید که جلسه حذف شده به هیچ وجه
        قابل بازگشت نیست!
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>
<script>
export default {
  emits: ["getSecondConfirmation"],
  props: {
    selectedSchedulesLength: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    getSecondConfirmation() {
      this.$emit("getSecondConfirmation");
    },
  },
  components: {
    CustomDeleteDialog,
    BCol,
  },
};
import { BCol } from "bootstrap-vue";
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
</script>
